// Editorial / DataLab constants for the admin portal.

// HOUSE_AUTHOR_ID is the auth_users.id of the "ProProp Data Lab" house
// byline identity (backend migration 000007 / constants.HouseAuthorID,
// epic PROP-41). Articles composed from the admin portal are authored
// by this identity; the Compose surface filters its resumable-drafts
// list to house-authored rows by this id.
export const HOUSE_AUTHOR_ID = "house-propwise-data-lab";
